import { ref } from 'vue'

export const globalLoadingVisible = ref(false)

let pendingRequests = 0
let showTimer = null
let hideTimer = null
let shownAt = 0

// Do not flash the overlay for normal fast requests.
const SHOW_DELAY = 1000
const MIN_VISIBLE_TIME = 360

export const startGlobalLoading = () => {
  pendingRequests += 1
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  if (globalLoadingVisible.value || showTimer) return

  showTimer = setTimeout(() => {
    showTimer = null
    if (pendingRequests > 0) {
      shownAt = Date.now()
      globalLoadingVisible.value = true
    }
  }, SHOW_DELAY)
}

export const stopGlobalLoading = () => {
  pendingRequests = Math.max(0, pendingRequests - 1)
  if (pendingRequests > 0) return

  if (showTimer) {
    clearTimeout(showTimer)
    showTimer = null
  }
  if (!globalLoadingVisible.value) return

  const remaining = Math.max(0, MIN_VISIBLE_TIME - (Date.now() - shownAt))
  hideTimer = setTimeout(() => {
    hideTimer = null
    if (pendingRequests === 0) globalLoadingVisible.value = false
  }, remaining)
}
